/**
 * @generated SignedSource<<a05dd4e9a1c94fc80ce101d23864c0ea>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type McpServersOnboardingContentDeleteMutation$variables = {
  id: any;
};
export type McpServersOnboardingContentDeleteMutation$data = {
  readonly deleteCustomMcpServer: {
    readonly error: string | null | undefined;
    readonly server: {
      readonly id: any;
    } | null | undefined;
  };
};
export type McpServersOnboardingContentDeleteMutation = {
  response: McpServersOnboardingContentDeleteMutation$data;
  variables: McpServersOnboardingContentDeleteMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "id",
        "variableName": "id"
      }
    ],
    "concreteType": "CustomMcpServerPayload",
    "kind": "LinkedField",
    "name": "deleteCustomMcpServer",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "GraphQLCustomMcpServer",
        "kind": "LinkedField",
        "name": "server",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "error",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "McpServersOnboardingContentDeleteMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "McpServersOnboardingContentDeleteMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "c83af079f3cb20bbe675af1dc5c162b7",
    "id": null,
    "metadata": {},
    "name": "McpServersOnboardingContentDeleteMutation",
    "operationKind": "mutation",
    "text": "mutation McpServersOnboardingContentDeleteMutation(\n  $id: GlobalID!\n) {\n  deleteCustomMcpServer(id: $id) {\n    server {\n      id\n    }\n    error\n  }\n}\n"
  }
};
})();

(node as any).hash = "ffbb10a6ad55d2c1eadb10aa9d57f880";

export default node;
